/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchCrownDescriptionParcelResultDto } from '../../models/search-crown-description-parcel-result-dto';

export interface SearchForCrownDescriptionParcels$Params {
  parish_or_township_code: string;
  parish_or_township_name: string;
  allotment?: string;
  section?: string;
  subdivision?: string;
  portion?: string;
  block?: string;
}

export function searchForCrownDescriptionParcels(
  http: HttpClient,
  rootUrl: string,
  params: SearchForCrownDescriptionParcels$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchCrownDescriptionParcelResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForCrownDescriptionParcels.PATH,
    'get',
  );
  if (params) {
    rb.query('parish_or_township_code', params.parish_or_township_code, {});
    rb.query('parish_or_township_name', params.parish_or_township_name, {});
    rb.query('allotment', params.allotment, {});
    rb.query('section', params.section, {});
    rb.query('subdivision', params.subdivision, {});
    rb.query('portion', params.portion, {});
    rb.query('block', params.block, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchCrownDescriptionParcelResultDto>;
      }),
    );
}

searchForCrownDescriptionParcels.PATH = '/search/crown-description/parcel';
